module.exports = __webpack_public_path__ + "static/media/receive.5b4a97bb.png";